module.exports = __webpack_public_path__ + "img/icon-bedroom.06564294.svg";